module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_3016.bfa1fc34.png";